/* eslint-disable max-len */
const React = require('react');

const HomeFooterSupport = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path fill="#000" fillOpacity=".8" fillRule="nonzero" d="M16.004 2.195a1.8 1.8 0 0 1 1.8 1.8v9.124a1.8 1.8 0 0 1-1.8 1.8h-5.838L4.6 18.259v-3.34H4a1.8 1.8 0 0 1-1.8-1.8V3.995a1.8 1.8 0 0 1 1.8-1.8h12.004zm0 1.2H4a.6.6 0 0 0-.6.6v9.124a.6.6 0 0 0 .6.6h1.8v2.421l4.034-2.421h6.17a.6.6 0 0 0 .6-.6V3.995a.6.6 0 0 0-.6-.6zM14.2 6.391v1.2H5.8v-1.2h8.4z" />
  </svg>
);

module.exports = HomeFooterSupport;
